import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Lock, Sparkles, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const PremiumLessonStop = ({ next, open, onOpenChange }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const skip = next?.skip;
  const tier = next?.tier === "basic" ? "Basic" : "Premium";
  const go = () => navigate(skip.kind === "quiz" ? `/quizzes/${skip.id}` : `/lessons/${skip.id}`);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="premium-lesson-stop" className="max-w-md rounded-2xl">
        <div className="inline-flex items-center gap-1.5 self-start rounded-full bg-amber-50 border border-amber-200 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-amber-700">
          <Lock size={11} /> {t("lessonPlayerUi.premiumAhead", { tier })}
        </div>
        <DialogTitle className="font-display text-2xl font-black text-slate-900" data-testid="premium-lesson-stop-title">{next?.title}</DialogTitle>
        <DialogDescription className="text-sm text-slate-600">
          {next?.description || t("lessonPlayerUi.premiumAheadBody", { tier })}
        </DialogDescription>
        <p className="text-xs text-slate-500">{t("lessonPlayerUi.premiumAheadNote")}</p>
        <div className="mt-2 flex flex-col sm:flex-row gap-2">
          <Button data-testid="premium-lesson-stop-upgrade" onClick={() => navigate("/pricing")} className="flex-1 bg-amber-500 hover:bg-amber-600 text-slate-900 gap-2">
            <Sparkles size={15} /> {t("lessonPlayerUi.premiumUpgrade", { tier })}
          </Button>
          {skip && (
            <Button data-testid="premium-lesson-stop-skip" variant="outline" onClick={go} className="flex-1 gap-2">
              {skip.kind === "quiz" ? t("lessonPlayerUi.premiumSkipQuiz") : t("lessonPlayerUi.premiumSkip")} <ArrowRight size={15} />
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
